import { translations } from "./translations";

export function getCurrentLanguage() {
  return localStorage.getItem("site_lang") || "en";
}

export function setCurrentLanguage(lang) {
  localStorage.setItem("site_lang", lang);
  document.documentElement.lang = lang;
  window.dispatchEvent(new CustomEvent("language-changed", { detail: lang }));
}

export function translate(key, lang = getCurrentLanguage()) {
  return (
    translations?.[lang]?.[key] ??
    translations?.en?.[key] ??
    key
  );
}